<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <!--           <div class="row">

              <div class="col-md-6"><h5>Pacientes</h5></div>
              <div class="col-md-6">
                <div style="text-align: right">
                  <router-link to="/admin/cadastrar-paciente">
                    <button id="btn_new_user" type="button">
                      Novo Paciente
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
-->
            <div class="row">
              <div class="col-xl-1 col-lg-2">
                <div class="form-group">
                  <label>Código</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="state.codigo_busca"
                    @keyup.enter="buscar"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4">
                <div class="form-group">
                  <label>Paciente</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="state.nome_busca"
                    @keyup.enter="buscar"
                  />
                </div>
              </div>
              <div class="col-xl-1 col-lg-2 div_btn_busca">
                <div class="form-group">
                  <button
                    type="button"
                    class="btn_busca"
                    :disabled="state.is_loading"
                    @click="buscar"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 div_btn_busca">
                <button
                  class="btn_busca dropdown-toggle"
                  type="button"
                  @click="openMiniModal"
                >
                  Busca Detalhada
                </button>
                <!-- 
            <div class="mini-modal">
              <div class="mb-2 div_avan">
                <button class="btn_busca_avan" type="button" @click="buscarAvan">
                  Buscar
                </button>
                <button class="btn_busca_avan" type="button" @click="limparAvanca">
                  Limpar
                </button>
              </div>
              <select v-model="filtros.genero">
                <option selected value="">Selecione um Gênero</option>
                <option value="FEMININO">Feminino</option>
                <option value="MASCULINO">Masculino</option>
                <option value="OUTROS">Outros</option>
              </select>
              <select v-model="filtros.doenca">
                <option selected value="">Selecione uma Patologia</option>
                <option v-for="patologia in state.patologias" :key="patologia.id" :value="patologia.id">
                  {{ patologia.nome }}
                </option>
              </select>
              <select v-model="filtros.tipo_oleo">
                <option selected value="">Selecione um Tipo de Óleo</option>
                <option v-for="oleo in state.tipos_oleos" :key="oleo.id" :value="oleo.id">
                  {{ oleo.nome }}
                </option>
              </select>
              <select v-model="filtros.idade">
                <option selected value="">Selecione uma Idade</option>
                <option value="16-30">16-30</option>
                <option value="31-45">31-45</option>
                <option value="46-60">46-60</option>
                <option value="61+">61+</option>
              </select>
            </div> -->
              </div>
              <div class="col-xl-3 div_btn_novo">
                <div class="form-group">
                  <a href="/admin/cadastrar-paciente">
                    <button type="button" class="btn_novo">Cadastrar</button>
                  </a>
                </div>
              </div>
            </div>

            <div class="row" v-if="state.mini_modal">
              <div class="col-sm-3 col-lg-2">
                <select v-model="filtros.genero">
                  <option selected value="">Selecione um Gênero</option>
                  <option value="FEMININO">Feminino</option>
                  <option value="MASCULINO">Masculino</option>
                  <option value="OUTROS">Outros</option>
                </select>
              </div>
              <div class="col-sm-3 col-lg-2">
                <select v-model="filtros.doenca">
                  <option selected value="">Selecione uma Patologia</option>
                  <option
                    v-for="patologia in state.patologias"
                    :key="patologia.id"
                    :value="patologia.id"
                  >
                    {{ patologia.nome }}
                  </option>
                </select>
              </div>
              <div class="col-sm-3 col-lg-2">
                <select v-model="filtros.tipo_oleo">
                  <option selected value="">Selecione um Tipo de Óleo</option>
                  <option
                    v-for="oleo in state.tipos_oleos"
                    :key="oleo.id"
                    :value="oleo.id"
                  >
                    {{ oleo.nome }}
                  </option>
                </select>
              </div>
              <div class="col-sm-3 col-lg-2">
                <select v-model="filtros.medico_id">
                  <option selected value="">Selecione um Médico</option>
                  <option
                    v-for="medico in state.medicos"
                    :key="medico.id"
                    :value="medico.id"
                  >
                    {{ medico.nome }}
                  </option>
                </select>
              </div>
              <div class="col-sm-3 col-lg-2">
                <select v-model="filtros.idade">
                  <option selected value="">Selecione uma Idade</option>
                  <option value="16-30">16-30</option>
                  <option value="31-45">31-45</option>
                  <option value="46-60">46-60</option>
                  <option value="61+">61+</option>
                </select>
              </div>
              <div class="mb-2 div_avan">
                <button
                  class="btn_busca_avan"
                  type="button"
                  :disabled="state.is_loading"
                  @click="buscarAvan"
                >
                  Buscar
                </button>
                <button
                  class="btn_busca_avan"
                  type="button"
                  :disabled="state.is_loading"
                  @click="limparAvanca"
                >
                  Limpar
                </button>
              </div>
            </div>
          </div>
          <hr />

          <div class="card-body">
            <div class="barra_listagem">
              <span v-if="state.is_loading">Carregando pacientes...</span>
              <span v-else>
                Quantidade: {{ state.paginacao.total }}
                <template v-if="state.paginacao.total > 0">
                  (exibindo {{ state.pacientes.length }})
                </template>
              </span>

              <label class="itens_por_pagina">
                Itens por página
                <select
                  v-model.number="state.paginacao.por_pagina"
                  :disabled="state.is_loading"
                  @change="trocarTamanhoPagina"
                >
                  <option :value="25">25</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </label>
            </div>

            <table class="table table-hover">
              <thead style="background: #014a4a">
                <tr>
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Telefone</th>
                  <th>Email</th>
                  <th>Tipo</th>
                  <th style="text-align: center">Ação</th>
                </tr>
              </thead>
              <tbody>
                <corpo-tabela-paciente-loading v-if="state.is_loading" />
                <template v-else>
                  <corpo-tabela-paciente
                    v-for="paciente in state.pacientes"
                    :key="paciente.id"
                    :paciente="paciente"
                    @deletePaciente="deletePaciente"
                  />
                  <tr v-if="state.pacientes.length === 0">
                    <td colspan="6" class="text-center">
                      Nenhum paciente encontrado.
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <div v-if="state.paginacao.ultima_pagina > 1" class="paginacao">
              <button
                type="button"
                class="btn_pagina"
                :disabled="state.is_loading || state.paginacao.pagina === 1"
                @click="irPara(state.paginacao.pagina - 1)"
              >
                Anterior
              </button>

              <button
                v-if="paginasVisiveis[0] > 1"
                type="button"
                class="btn_pagina"
                :disabled="state.is_loading"
                @click="irPara(1)"
              >
                1
              </button>
              <span v-if="paginasVisiveis[0] > 2" class="reticencias">…</span>

              <button
                v-for="pagina in paginasVisiveis"
                :key="pagina"
                type="button"
                class="btn_pagina"
                :class="{ pagina_atual: pagina === state.paginacao.pagina }"
                :disabled="state.is_loading"
                @click="irPara(pagina)"
              >
                {{ pagina }}
              </button>

              <span
                v-if="
                  paginasVisiveis[paginasVisiveis.length - 1] <
                  state.paginacao.ultima_pagina - 1
                "
                class="reticencias"
                >…</span
              >
              <button
                v-if="
                  paginasVisiveis[paginasVisiveis.length - 1] <
                  state.paginacao.ultima_pagina
                "
                type="button"
                class="btn_pagina"
                :disabled="state.is_loading"
                @click="irPara(state.paginacao.ultima_pagina)"
              >
                {{ state.paginacao.ultima_pagina }}
              </button>

              <button
                type="button"
                class="btn_pagina"
                :disabled="
                  state.is_loading ||
                  state.paginacao.pagina === state.paginacao.ultima_pagina
                "
                @click="irPara(state.paginacao.pagina + 1)"
              >
                Próxima
              </button>

              <span class="resumo_pagina">
                Página {{ state.paginacao.pagina }} de
                {{ state.paginacao.ultima_pagina }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { computed, onMounted, reactive } from "vue";
import CorpoTabelaPaciente from "../../components/CorpoTabelaPaciente";
import CorpoTabelaPacienteLoading from "../../components/CorpoTabelaPaciente/Loading.vue";
import services from "../../services";
import { useStorage } from "vue3-storage";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
export default {
  components: {
    CorpoTabelaPaciente,
    CorpoTabelaPacienteLoading,
  },
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");

    const state = reactive({
      pacientes: [],
      is_loading: true,
      // "lista" | "simples" | "avancada": guarda de onde veio a listagem atual,
      // para trocar de pagina refazer a mesma consulta.
      modo: "lista",
      filtro_aplicado: {},
      paginacao: {
        pagina: 1,
        por_pagina: 25,
        total: 0,
        ultima_pagina: 1,
      },
      codigo_busca: "",
      nome_busca: "",
      mini_modal: false,
      patologias: [],
      tipos_oleos: [],
      medicos: [],
    });

    const filtros = reactive({
      genero: "",
      doenca: "",
      tipo_oleo: "",
      idade: "",
      medico_id: "",
    });

    // Janela de paginas ao redor da atual: com 55 paginas, listar todas nao cabe.
    const paginasVisiveis = computed(() => {
      const { pagina, ultima_pagina: ultima } = state.paginacao;
      const inicio = Math.max(1, Math.min(pagina - 2, ultima - 4));
      const fim = Math.min(ultima, Math.max(pagina + 2, 5));
      const paginas = [];
      for (let i = inicio; i <= fim; i++) paginas.push(i);
      return paginas;
    });

    onMounted(() => {
      fetchPacientes();
      fetchPatologias();
      fetchTipoOleo();
      fetchMedicos();
    });

    async function fetchPatologias() {
      try {
        const { data } = await services.patologia.getAll({ token });
        state.patologias = data;
      } catch (error) {
        void error;
      }
    }

    async function fetchTipoOleo() {
      try {
        const { data } = await services.tipos_oleo.getAll({ token });
        state.tipos_oleos = data;
      } catch (error) {
        void error;
      }
    }

    async function fetchMedicos() {
      try {
        const { data } = await services.medicos.getAll({ token });
        state.medicos = data;
      } catch (error) {
        void error;
      }
    }

    async function fetchPacientes() {
      state.modo = "lista";
      await carregarLista(1);
    }

    function consultaAtual(pagina) {
      const paginacao = { pagina, por_pagina: state.paginacao.por_pagina };

      if (state.modo === "simples") {
        return services.paciente.busca({
          codigo: state.codigo_busca,
          nome: state.nome_busca,
          token,
          ...paginacao,
        });
      }

      if (state.modo === "avancada") {
        return services.paciente.pesquisaAvan(
          state.filtro_aplicado,
          token,
          paginacao
        );
      }

      return services.paciente.getAll({ token, ...paginacao });
    }

    // Centraliza o liga/desliga do loader: sem o finally, uma falha na API
    // deixaria o esqueleto girando para sempre.
    async function carregarLista(pagina) {
      state.is_loading = true;
      try {
        const { data } = await consultaAtual(pagina);
        aplicarPagina(data, pagina);
      } catch (error) {
        state.pacientes = [];
        Object.assign(state.paginacao, { pagina: 1, total: 0, ultima_pagina: 1 });
        toast.error("Não foi possível carregar os pacientes.");
      } finally {
        state.is_loading = false;
      }
    }

    // O backend so pagina quando recebe per_page; se algum dia responder um
    // array puro, a tela continua funcionando como pagina unica.
    function aplicarPagina(payload, paginaPedida) {
      if (Array.isArray(payload)) {
        state.pacientes = payload;
        Object.assign(state.paginacao, {
          pagina: 1,
          total: payload.length,
          ultima_pagina: 1,
        });
        return;
      }

      state.pacientes = Array.isArray(payload.data) ? payload.data : [];
      Object.assign(state.paginacao, {
        pagina: Number(payload.current_page) || paginaPedida || 1,
        total: Number(payload.total) || 0,
        ultima_pagina: Number(payload.last_page) || 1,
      });
    }

    async function irPara(pagina) {
      if (
        state.is_loading ||
        pagina < 1 ||
        pagina > state.paginacao.ultima_pagina ||
        pagina === state.paginacao.pagina
      ) {
        return;
      }
      await carregarLista(pagina);
    }

    async function trocarTamanhoPagina() {
      await carregarLista(1);
    }

    async function buscar() {
      if (state.is_loading) return;

      if (state.codigo_busca.length == 0 && state.nome_busca.length == 0) {
        await fetchPacientes();
        return;
      }
      state.modo = "simples";
      await carregarLista(1);
    }

    async function deletePaciente(id) {
      if (confirm("Deseja remover este paciente?")) {
        try {
          const { data } = await services.paciente.delete({
            id: id,
            token,
          });
          if (data.status != 200) {
            alert("Erro ao deletar paciente.");
          } else {
            // Se o ultimo item da pagina foi removido, recua uma pagina.
            const pagina =
              state.pacientes.length === 1 && state.paginacao.pagina > 1
                ? state.paginacao.pagina - 1
                : state.paginacao.pagina;
            await carregarLista(pagina);
          }
        } catch (error) {
        void error;
      }
      }
    }

    function openMiniModal() {
      if (state.mini_modal === false) {
        state.mini_modal = true;
      } else {
        state.mini_modal = false;
      }
    }

    async function buscarAvan() {
      // Filtrando apenas os campos que foram preenchidos
      const filtro = Object.fromEntries(
        Object.entries(filtros).filter(([, value]) => value !== "")
      );

      // Chamando a API com os filtros
      state.modo = "avancada";
      state.filtro_aplicado = filtro;
      await carregarLista(1);
    }

    async function limparAvanca() {
      await fetchPacientes();
      filtros.genero = "";
      filtros.doenca = "";
      filtros.tipo_oleo = "";
      filtros.medico_id = "";
      filtros.idade = "";
    }
    //   try {
    //     const response = await services.paciente.pesquisaAvan(filtro, token);
    //     state.pacientes = response.data;
    //   } catch (error) {
    //   }
    return {
      state,
      filtros,
      paginasVisiveis,
      irPara,
      trocarTamanhoPagina,
      deletePaciente,
      buscar,
      openMiniModal,
      buscarAvan,
      limparAvanca,
    };
  },
};
</script>
<style scoped>
.header_gradiant {
  background: linear-gradient(
    50deg,
    #007c7c 0%,
    #030c0c 100%,
    #007c7c
  ) !important;
}

.card .card-body {
  padding-top: 0 !important;
}

.card .card-header {
  padding-bottom: 0 !important;
}

input {
  color: #000;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  font-size: 12pt;
}

input:focus {
  color: #000;
  border: solid 2px rgb(40, 149, 146);
  border-color: rgb(40, 149, 146);
}

label {
  color: #000;
  margin-bottom: 0;
  font-size: 14pt;
}

select {
  margin-bottom: 10px;
  color: #000;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  padding: 10px;
  font-size: 12pt;
  width: 100%;
  border-radius: 4px;
}

select:focus {
  color: #000;
  border: solid 2px rgb(40, 149, 146);
  border-color: rgb(40, 149, 146);
}

.div_btn_busca {
  margin-top: 30px;
}

.btn_busca {
  width: 100%;
  background-color: transparent;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  border-radius: 5px;
  height: 45px;
  padding: 5px;
  transition: 0.4s;
  color: rgb(10, 36, 35);
}

.btn_busca:hover {
  background-color: rgb(10, 36, 35);
  color: rgb(255, 255, 255);
  transform: none;
}

.div_avan {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn_busca_avan {
  width: 100px;
  background-color: transparent;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  border-radius: 5px;
  padding: 5px;
  transition: 0.4s;
  color: rgb(10, 36, 35);
  margin: 5px;
}

.btn_busca_avan:hover {
  background-color: rgb(10, 36, 35);
  color: rgb(255, 255, 255);
  transform: none;
}

.mini-modal {
  padding: 10px;
  background: gainsboro;
  border-radius: 0px 0px 5px 5px;
}

svg {
  height: 20px;
  transition: 0.4s;
  width: 100%;
}

svg:hover {
  height: 30px;
  width: 100%;
}

.div_btn_cliente {
  margin-top: 30px;
  text-align: right;
}

th {
  background: rgba(181, 181, 181, 0.744) !important;
  color: #000 !important;
}

.div_btn_novo {
  margin-top: 30px;
  text-align: right;
}

.btn_novo {
  border: solid 2px rgb(22, 82, 78);
  border-color: rgb(10, 36, 35);
  border-radius: 5px;
  width: 50%;
  height: 45px;
  padding: 5px;
  transition: 0.4s;
  background-color: rgb(22, 82, 78);
  color: #fff;
}

.barra_listagem {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
}

.itens_por_pagina {
  align-items: center;
  display: flex;
  font-size: 11pt;
  gap: 8px;
  margin-bottom: 0;
}

.itens_por_pagina select {
  margin-bottom: 0;
  padding: 4px 8px;
  width: auto;
}

.paginacao {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
  padding: 12px 0;
}

.btn_pagina {
  background-color: transparent;
  border: solid 2px rgb(10, 36, 35);
  border-radius: 5px;
  color: rgb(10, 36, 35);
  min-width: 40px;
  padding: 5px 10px;
  transition: 0.4s;
}

.btn_pagina:hover:not(:disabled) {
  background-color: rgb(10, 36, 35);
  color: #fff;
  transform: none;
}

.btn_pagina:disabled {
  opacity: 0.45;
}

.pagina_atual {
  background-color: rgb(22, 82, 78);
  border-color: rgb(22, 82, 78);
  color: #fff;
}

.pagina_atual:disabled {
  opacity: 1;
}

.reticencias {
  color: rgb(10, 36, 35);
  padding: 0 2px;
}

.resumo_pagina {
  color: rgb(10, 36, 35);
  font-size: 11pt;
  margin-left: 10px;
}

@media (max-width: 768px) {
  .div_btn_busca {
    margin-top: 0;
  }

  .resumo_pagina {
    margin-left: 0;
    width: 100%;
    text-align: center;
  }
}
</style>